import * as React from "react";
import { useState, useEffect } from "react";
import Api from "../../services/Api";
import { ApiResponse, create } from "apisauce";

import * as urls from "../shared/urls";
import { Form, Button, InputGroup, FormControl } from "react-bootstrap";
import Input from "../Elements/Input";
import TextArea from "../Elements/TextArea";

import "./Assets/LicensePlateLookupTool.scss";
import CheckBox from "../Elements/CheckBox";
import { render } from "enzyme";

export interface ILicensePlateControllerProps {
  history: any;
}

export interface ILicensePlateControllerLocalState {
  licensePlateNumber: string;
  overrideLicensePlateValidationResponse: boolean;
  licensePlateValidationResponse: ILicensePlateResponse;
  licensePlateValidationResponseOverride: string;
}

export interface ILicensePlateResponse {
  LicensePlate?: string;
  PlateType?: string;
  YearPlateExpires?: string;
  StateOfRegistratioin?: string;
  VINNumber?: string;
  VehicleYear?: string;
  VehicleMakeCode?: string;
  VehicleMakeDesc?: string;
  VehicleModel?: string;
  VehicleStyleCode?: string;
  VehicleStyleDesc?: string;
  VehicleColor1?: string;
  VehicleColor2?: string;
  RegistrationType?: string;
  OwnerName?: string;
  OwnerAddress1?: string;
  OwnerAddress2?: string;
  OwnerCity?: string;
  OwnerZip?: string;
  InsuranceCompanyName?: string;
  InsurancePolicyNumber?: string;
}

export const trueFalse = [
  { id: 1, name: "true" },
  { id: 2, name: "false" }
];

export const mockResponse: ILicensePlateResponse = {
  VINNumber: "4S3BMHM68B3286050"
};

export class LicensePlateLookupTool extends React.Component<
  ILicensePlateControllerProps,
  ILicensePlateControllerLocalState
> {
  state = {
    licensePlateNumber: "",
    overrideLicensePlateValidationResponse: false,
    licensePlateValidationResponse: undefined,
    licensePlateValidationResponseOverride: ""
  };

  loadResponseFromDMV = () => {

    // now using SERVER to process license plate lookups, doesn't look like this tool is actually used because in prod has the mock response below:
    
    // const { licensePlateNumber } = this.state;
    // const {
    //   LICENSE_PLATE_LOOKUP_STAGING_URL,
    //   LICENSE_PLATE_ENDPOINT
    // } = urls;

    // const uri = `${LICENSE_PLATE_LOOKUP_STAGING_URL}?APIKey=${LICENSE_PLATE_LOOKUP_API_KEY}/`;

    // const api = create({
    //   baseURL: uri,
    //   headers: {
    //     "API-KEY": `${LICENSE_PLATE_LOOKUP_API_KEY}`
    //   }
    // });
    //TODO: This section should be put back in once the DMV endpoint is available to consume.
    // api
    //   .get(`${LICENSE_PLATE_ENDPOINT}`, { licensePlateNumber })
    //   .then((result: ApiResponse<any>) => {
    //     this.setLicensePLateValidationResponse(result.data);
    //   });

    this.setLicensePLateValidationResponse(mockResponse);
  };

  setLicensePLateValidationResponse = (value: ILicensePlateResponse) => {
    this.setState({
      licensePlateValidationResponse: value,
      licensePlateValidationResponseOverride: value.VINNumber
    });
  };

  setLicensePlateNumber = event => {
    const { name, value } = event.target;
    this.setState(
      {
        licensePlateNumber: value
      },
      () => {
        this.loadResponseFromDMV();
      }
    );
  };

  handleOverrideChange = () => {
    const { licensePlateValidationResponse } = this.state;
    this.setState(prevState => ({
      overrideLicensePlateValidationResponse: !prevState.overrideLicensePlateValidationResponse,
      licensePlateValidationResponseOverride:
        licensePlateValidationResponse.VINNumber
    }));
  };

  handleOverrideTextChange = event => {
    const { name, value } = event.target;
    this.setState({
      licensePlateValidationResponseOverride: value
    });
  };

  render() {
    const {
      licensePlateNumber,
      licensePlateValidationResponse,
      overrideLicensePlateValidationResponse,
      licensePlateValidationResponseOverride
    } = this.state;

    return (
      <React.Fragment>
        <Form.Group className="LicensePlateLookupTool">
          <Form.Label>License Plate Number</Form.Label>
          <Input
            className="licensePlateNumberInput"
            type="text"
            value={licensePlateNumber}
            onChange={this.setLicensePlateNumber}
          />

          {licensePlateValidationResponse !== undefined &&
            licensePlateNumber !== "" && (
              <React.Fragment>
                <Form.Group>
                  <Form>
                    <Form.Group>
                      <Form.Label className="formHeader">
                        Validation Response
                      </Form.Label>
                    </Form.Group>
                    <Form.Group controlId="overrideCheckbox">
                      <Form.Check
                        required
                        name="overrideCheckbox"
                        label="Override Validation Response"
                        onChange={this.handleOverrideChange}
                      />
                    </Form.Group>
                    {overrideLicensePlateValidationResponse === false && (
                      <InputGroup className="mb-3 overrideGroup">
                        <InputGroup.Prepend>
                          <InputGroup.Text id="inputGroup-sizing-default">
                            {licensePlateValidationResponse.VINNumber}
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    )}
                    {overrideLicensePlateValidationResponse === true && (
                      <FormControl
                        className="overrideTextBlock"
                        onFocus={event => {
                          const inputNode = event.target;
                          inputNode.setSelectionRange(
                            0,
                            inputNode.value.length
                          );
                        }}
                        type="text"
                        value={licensePlateValidationResponseOverride}
                        // value={
                        //   licensePlateValidationResponseOverride === ""
                        //     ? licensePlateValidationResponse.VINNumber
                        //     : licensePlateValidationResponseOverride
                        // }
                        onChange={this.handleOverrideTextChange}
                      />
                    )}
                  </Form>
                </Form.Group>
              </React.Fragment>
            )}
        </Form.Group>
      </React.Fragment>
    );
  }
}

export default LicensePlateLookupTool;
